export default {"src":"/_next/static/media/love-calculator-heart.7b8b3235.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};